import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ThemeProvider } from '@material-ui/core';

import { theme } from '@ha/dsl';
import {
  DateRangePicker,
  DATEPICKER_VARIANT,
} from 'ha/components/next/DatePicker';
import { DateRange } from 'ha/ui/next/DatePicker';
import { useIntl } from 'ha/i18n';

import DateRangePickerInputs from './DateRangePickerInputs';
import { DatePickerFieldValue } from '../../types';

const HomeDateRangePicker: React.FC<FieldRenderProps<DatePickerFieldValue>> = ({
  input,
}) => {
  const { value } = input;
  const { T } = useIntl();

  const datePickerValue: DateRange = React.useMemo(
    () => ({
      from: value.startDate ?? undefined,
      to: value.endDate ?? undefined,
    }),
    [value],
  );

  const handleDateChange = React.useCallback(
    (inputValue: DateRange) => {
      input.onChange({
        startDate: inputValue.from ?? null,
        endDate: inputValue.to ?? null,
      });
    },
    [input],
  );

  return (
    // use the default theme since homepage uses the custom one and overwrites fonts
    <ThemeProvider theme={theme}>
      <DateRangePicker
        value={datePickerValue}
        onDateChange={handleDateChange}
        variant={DATEPICKER_VARIANT.RESPONSIVE}
        clearDatesButton={T('Reset')}
        DatePickerInputs={DateRangePickerInputs}
        noEndDate
      />
    </ThemeProvider>
  );
};

export default HomeDateRangePicker;
